import { render, staticRenderFns } from "./RecipeRoot.vue?vue&type=template&id=1d1655fa&lang=pug&"
import script from "./RecipeRoot.vue?vue&type=script&lang=js&"
export * from "./RecipeRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports